import React from 'react';
import styles from './BinderNavigation.scss';
import {Tabs} from 'components/common/Tabs/Tabs';
import { GoBack } from 'components/common/Link';

export default function BinderNavigation ({ title , location, tabs, fixedNav, hasMaxWidth, homeRoute, isStudy }){
    const binderNavStyle = fixedNav ? styles.stuckBinderNavContainer : styles.binderNavigationContainer;
    const binderNavMaxWidthClass = hasMaxWidth ? styles.maxWidthModifier: '';
    const type = isStudy ? 'Studies' : 'Binders';
    
    return(
        <div className={`${binderNavStyle} ${binderNavMaxWidthClass}`} data-cy="binderNavigation">
            <GoBack
                data-test-id='hyp-binder-navigation-back'
                to={homeRoute}
            >
                Back to {type} List
            </GoBack>
            <div className={styles.binderTitle}>
                {title}
            </div>
            <Tabs tabs={tabs} location={location} />
        </div>
    );
}

